<template>
  <div class="page">
    <c-source-page
      :columns="columns"
      :filter="filter"
      :table="table"
      :pagination="pagination"
      resource="users"
      exportExcelURL="/users/resource.xlsx"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class Users extends Vue {

  tags = [];
  table = { data: [] }
  pagination = {}

  filter = [
    {
      prop: 'no_cont',
      label: '唯一编号',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'nickname_cont',
      label: '用户名',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'tag',
      label: '标签',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'is_employee_eq',
      label: '是否员工',
      form: {
        component: 'select',
        props: {
          clearable: true,
          options: [
            {
              label: '是',
              value: true
            },
            {
              label: '否',
              value: false
            }
          ]
        }
      }
    },
    {
      prop: 'is_distributor_eq',
      label: '是否分销商',
      form: {
        component: 'select',
        props: {
          clearable: true,
          options: [
            {
              label: '是',
              value: true
            },
            {
              label: '否',
              value: false
            }
          ]
        }
      }
    },
  ]

  get columns() {
    return createColumns.call(this, { tags: this.tags });
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get('/users', { params: { ...this.$route.query, ...params } });
    const tags = await this.$request.get('/tags', { taggable_type: 'User' });
    this.table.data = data;
    this.pagination = pagination;
    this.tags = tags;
  }
}

</script>
